/* eslint-disable */
import { cleanCompanyStore, getCompanyById } from './company';
import { IRequestAPIBody, apiManager } from '../REST';
import { IBodyItemResponse, IGetOrder, IGetOrderAPI, IPostItem, IPostOrderAttributes } from '../interfaces';
import { OrderProduct } from '../interfaces';
import { mapApi2UiField, mapUi2ApiField } from '../instruments';

export async function getOrder(id: string): Promise<IGetOrder> {
    const { resp, isError } = await apiManager.getApi('GET_ORDER', { id: id });
    const orderResponse = resp as IGetOrderAPI;
    const order = mapApi2UiField(orderResponse.order || {});

    order.products = order?.products?.map((product: OrderProduct) => {
        return {
            ...mapApi2UiField(product || {}),
        };
    });

    order.discount = mapApi2UiField(order?.discount || {});

    return {
        isError,
        order,
    };
}

export function getOrderRelations(id: string): void {
    getCompanyById(id);
}

export function cleanOrderTopUpRelation(): void {
    cleanCompanyStore();
}

export const postOrder = async (id: string, attributes: IPostOrderAttributes): Promise<IPostItem> => {
    const body: IRequestAPIBody = {
        order: {
            ...mapUi2ApiField(attributes),
        },
    };

    const { resp, isError } = await apiManager.getApi('POST_NEW_ORDER', { id }, body);
    const response = resp as IBodyItemResponse;
    const { errors } = await response;
    return { isError, errors, resp: response };
};

export const checkOutOrder = async (ordersId: string): Promise<IPostItem> => {
    const { resp, isError } = await apiManager.getApi('POST_ORDER_CHECKOUT', { id: ordersId });
    const response = resp as IBodyItemResponse;
    const { errors } = await response;
    return { isError, errors, resp: response };
};
